import * as React from 'react';
import { ActionIcon, Button } from '@mantine/core';
import { IconTrash } from '@tabler/icons-react';
import { openConfirmModal } from '@mantine/modals';
import { OpenConfirmModal } from '@mantine/modals/lib/context';
import { useTranslation } from 'react-i18next';

export interface DeleteButtonProps {
    minimal?: boolean;
    disabled?: boolean;
    loading?: boolean;
    confirmModalProps: OpenConfirmModal;
}

export const DeleteButton: React.FC<DeleteButtonProps> = ({ confirmModalProps, minimal, disabled, loading }) => {
    const openDiscardChangesModal = () => {
        openConfirmModal(confirmModalProps);
    };
    const { t } = useTranslation();

    return minimal ? (
        <ActionIcon color="red" variant="filled" onClick={openDiscardChangesModal} disabled={disabled}>
            <IconTrash size={14} />
        </ActionIcon>
    ) : (
        <Button
            color="red"
            onClick={openDiscardChangesModal}
            leftIcon={<IconTrash size={14} />}
            loading={loading}
            disabled={disabled}
        >
            {t('delete', { ns: 'common' })}
        </Button>
    );
};
